<template>
  <v-app>
      <v-container fluid>

        <v-select
        v-model="grafica_seleccionada"
        :items="items"
        item-text="name"
        item-value="id"
        >
        </v-select>
        {{  }}
        <div class="mt-3 pl-2 pr-2">
          <div>
            <span class="display-1">{{titulo}}</span>
           
          
            <!--Leyenda Gráfica-->
            <v-layout class="mt-1">
              <v-flex xs12>
                <line-chart
                    :unidades="unidadesGrafica"
                    :chart-data="datosGrafica"
                    :tromel="isTromel"
                ></line-chart>
              </v-flex>
            </v-layout>
          </div>

        
          <!--Leyenda inferior-->
          <v-row class="text-center mt-2 blue-grey--text"> 
              <v-col>
                <v-icon color="#FF9800">mdi-information</v-icon> SECADO
              </v-col>      
              <v-col>
                <v-icon color="#2196F3">mdi-information</v-icon> HIGIENIZACIÓN 
              </v-col>  
              <v-col title="Tiempo en alcanzar los 80º">         
                <v-icon>mdi-alarm</v-icon> {{calcularTiempoSecado()}} 
              </v-col>                      
          </v-row>

          <!--TABLA CON INFO ADICIONAL-->
          <v-divider class="mt-2" color="#CFD8DC"/>
         
          <v-data-table
            class="mt-4"
              :headers="headers"
              disable-sort
              hide-default-footer
              :items="infoAdicional">

              <template v-slot:[`item.ensayo`]>{{numEnsayo}}</template>
              <!-- <template v-slot:[`item.lote`]>{{lote}}</template> -->
              <template v-slot:[`item.trabajador`]>{{trabajador}}</template>
              <template v-slot:[`item.lote_mp`]>{{lote_mp}}</template>
              <template v-slot:[`item.lote_bolson`]>{{lote_bolson}}</template>
              <template v-slot:[`item.lote_mem_hig`]>{{lote_mem_hig}}</template>
              <template v-slot:[`item.cuerpos_extr`]>
                <div v-if="cuerpos_extranos">
                  SÍ
                </div>
                <div v-else>
                  NO
                </div>
              </template>
              <template v-slot:[`item.kg_membrana_t2`]>{{kg_membrana_t2}}</template>
              <template v-slot:[`item.fase`]>{{last_fase}}</template>
              <template v-slot:[`item.temperatura_salida`]>{{ultima_temperatura_salida}}</template>
              <template v-slot:[`item.temperatura_tromel`]>{{ultima_temperatura_tromel}}</template>
              <template v-slot:[`item.caudal_aire`]>{{ultimo_caudal_aire}}</template>
              <template v-slot:[`item.estado`]>{{ultimo_estado}}</template>
          </v-data-table>
        </div>
      </v-container>
  </v-app>
</template>

<script>
import { mapActions,mapGetters, mapState } from "vuex";
// import moment from 'vue-moment';
import moment from 'moment-timezone';


import LineChart from '../components/LineChart.vue'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale,
} from 'chart.js'
ChartJS.register(  Title,
  Tooltip,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale)

  export default {
    name: 'Home',
    components: {
      LineChart
    },
    //FIN DE COMPONENTES
   
    //FIN DE PROPIEDADES
    data() {
      return {
        grafica_seleccionada:1,
        items:[
          {'id':1,name:'Temperatura Tromel'},
          {'id':2,name:'Temperatura Resistencias'},
          {'id':3,name:'Caudal'},
        ],

        ultima_fase:-1,
        trabajador:'-',
        numEnsayo:'-',
        lote_mp:'-',
        lote_bolson:'-',
        lote_mem_hig:'',
        fecha: '',
        // lote_membrana_hig:'-',
        cuerpos_extranos:'-',
        kg_membrana_t2:'-',
        fecha_temp:'',
        mensajes:{
          datos:[],
          estados:[]
        },
        infoAdicional:[{
        'ensayo':'-',
        'lote_mp':'-',
        'lote_bolson':'-',
        'lote_membrana_hig':'-',
        'cuerpos_extranos':'-',
        'kg_membrana_t2':'-',
        'trabajador':'-',
        'fase':'-',
        'temperatura_salida':false,
        'temperatura_tromel':false,
        'caudal_aire':false,
        'estado':'-',
        }],
        headers:[
          {text:"CICLO", align:"center", value:"ensayo"},
          {text:"LOTE MP", align:"center", value:"lote_mp"}, 
          {text:"LOTE Bolson", align:"center", value:"lote_bolson"},
          {text:"LOTE mem higenizada", align:"center", value:"lote_mem_hig"},
          // {text:"Cuerpos extraños", align:"center", value:"cuerpos_extr"},
          {text:"KG memrbana T2", align:"center", value:"kg_membrana_t2"},
          {text:"Trabajador", align:"center", value:"trabajador"},
          {text:"Fase", align:"center", value:"fase"},
          {text:"TEMPERATURA SALIDA", align:"center", value:"temperatura_salida"},
          {text:"TEMPERATURA TROMEL", align:"center", value:"temperatura_tromel"},
          {text:"CAUDAL AIRE", align:"center", value:"caudal_aire"},
          {text:"ESTADO", align:"center", value:"estado" },
        ],
        ultimoEnsayo: -1,
      }
    },

    //FIN DE DATOS
    methods: {
       ...mapActions('eggnovo',['set_fallo_hignienizacion1','set_fallo_hignienizacion2','set_cicloDia','set_horaCicloAnterior','set_previos_horno']),
       ...mapActions('nodered',['doSubscribe','doPublish']),
       choosePhaseColor : (ctx) => {
        if(ctx.p0.raw.fase == ctx.p1.raw.fase){
          
          if([2].includes(ctx.p1.raw.fase))return '#FF9800'
          if([4].includes(ctx.p1.raw.fase))return '#99ff33'
          else return '#2196F3'
        }else{
          return '#FCAA00'
        }
       },
        // ctx.p0.raw.fase == ctx.p1.raw.fase ? ctx.p1.raw.fase == 2 ? '#FF9800' : '#2196F3' : ,
      //Cuando se abre la página web recupera los datos anteriores del ensayo
      tratar_previos(mensaje_pre){
        let mensaje = JSON.parse(mensaje_pre)
        // console.log("tratar_previos, mensaje: " + mensaje)
        console.log("PREVIOS -> " + mensaje_pre)
        this.trabajador = (mensaje.hasOwnProperty("trabajador"))?mensaje.trabajador:'';
        this.lote_mp = (mensaje.hasOwnProperty("lote_mp"))?mensaje.lote_mp:'';
        this.lote_bolson = (mensaje.hasOwnProperty("lote_bolson"))?mensaje.lote_bolson:'';
        this.cuerpos_extranos = (mensaje.hasOwnProperty("cuerpos_extranos"))?mensaje.cuerpos_extr:'';
        this.kg_membrana_t2 = (mensaje.hasOwnProperty("kg_membrana_t2"))?mensaje.kg_membrana_t2:'';
        this.lote_mem_hig = (mensaje.hasOwnProperty("lote_mem_hig"))?mensaje.lote_mem_hig:'';
        
        if(mensaje.hasOwnProperty("datos")){
          this.mensajes.datos= mensaje.datos
          this.ultima_fase = mensaje.estado;
        }else{
          this.ultima_fase=-1;
        }
  
      },

      tratar_ensayos(mensaje){
        // console.log(`ESTE ES UN MENSAJE DE ENSAYO: ${mensaje}`)
        //Limpiar buffer de temperaturas
        let a = JSON.parse(mensaje)
        

        //this.mensajes.estados.push(a)
        this.trabajador = a.trabajador
        this.lote_mp = a.lote_mp
        this.lote_bolson = a.lote_bolson
        // this.cuerpos_extranos = a.cuerpos_extranos
        // console.log("los cuerpos extraaaaños")
        // console.log(cuerpos_extranos)
        this.lote_membrana_hig = a.lote_membrana_hig
        this.kg_membrana_t2 = a.kg_membrana_t2
        this.ultima_fase=a.estado;
        this.fecha = a.fecha
        if(a.estado==0){
          this.mensajes.datos = []
        }
      },
      tratar_produccion(mensaje){
        //console.log(`ESTE ES UN MENSAJE DE temperatura: ${mensaje}`)
        const b = JSON.parse(mensaje)
        this.mensajes.datos.push(b)
        //console.log(b)
        this.ultima_fase=b.fase;
        this.fecha = b.fecha
        //console.log('Se añadio la temperatura')
      },    
      eliminar_caracteres(fecha){
        let nueva = ''
        nueva = fecha.substring(11,23)
        let nueva2 = nueva.replace(/:/g,'')
        nueva2 = Math.round(nueva2)
        return nueva2
      },  
      getTimeFromDate(fecha){
        return fecha.split('T')[1].substring(0,8);
      },   
      parseDia(){
          let result = ''
          if(this.mensajes.datos.length==0)
            return result
          let primera_temp = this.mensajes.datos[0].fecha
          return primera_temp
      },

      calcularTiempoSecado() {
        let result = []
        this.mensajes.datos.map(item => {
            if(item.fase == '2'){
                result.push(item)
            }
        })

        return this.segundosAminutos(result.length)
      },

      segundosAminutos(duration){   
          // Hours, minutes and seconds
          var hrs = ~~(duration / 3600);
          var mins = ~~((duration % 3600) / 60);
          var secs = ~~duration % 60;

          // Output like "1:01" or "4:03:59" or "123:03:59"
          var ret = "";

          if (hrs > 0) {
              ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
          }

          ret += "" + mins + ":" + (secs < 10 ? "0" : "");
          ret += "" + secs;
          return ret;
      },

      roundToTwo(num) {
        return +(Math.round(num + "e+2")  + "e-2");
      },

      nombreCiclo(){
        // let fecha = new Date().toISOString()
        // let dia = fecha.split('T')[0].replaceAll('-','/')
        // let horaActual = parseInt(fecha.split('T')[1].substring(0,2)) + 2 // Horario español
        // if(this.horaCicloAnterior == ''){ //Entramos cuando inicalizamos todo
        //   this.set_horaCicloAnterior(horaActual)
        //   this.set_cicloDia(1)
        //   // this.prueba = horaActual < 6 ? this.diaAnterior() + '-' + this.cicloDia : dia + '-' + this.cicloDia
        //   return horaActual < 6 ? this.diaAnterior() + '-' + this.cicloDia : dia + '-' + this.cicloDia
        // }else{// Despues de inicializar
        //   if(this.horaCicloAnterior < 6 & horaActual >= 6){ //Cambio de día!
        //     this.set_cicloDia(1)
        //     // this.prueba = dia + '-' + this.cicloDia
        //   }else{ // Dentro del mismo diclo de día
        //     this.set_cicloDia(this.cicloDia + 1)
        //   }
        //   this.set_horaCicloAnterior(horaActual)
        //   return dia + '-' + this.cicloDia
        // }
        return fecha;
      },

      diaAnterior(){
        const yesterday = new Date()
        yesterday.setDate(yesterday.getDate() - 1)
        return this.formatDate(yesterday)
      },

      padTo2Digits(num) {
        return num.toString().padStart(2, '0');
      },

      formatDate(date) { // yyyy-mm-dd
        return [
          date.getFullYear(),
          this.padTo2Digits(date.getMonth() + 1),
          this.padTo2Digits(date.getDate()),
        ].join('/');
      },

    
     
    },
    //FIN DE METODOS
    computed:{
      ...mapState([
        'state',
        'client',
       
      ]),
      ...mapState('nodered',[
        'client', 'subscriptions',
      ]),
      ...mapState('eggnovo',[ 
        'higienizacion1',
        'higienizacion2',
        'tiempoFalloHigienizacion1',
        'tiempoFalloHigienizacion2',
        'cicloDia',
        'horaCicloAnterior']),
      //Fase del último mensaje recibido
      last_fase(){
        let resultado='-'
       
        switch (this.ultima_fase) {
          case 0:
            resultado='CERO'
            break;
          case 1:
            resultado='OBTENIENDO DATOS DE CICLO'
            break;
          case 2:
            resultado='SECADO'
            break;
          case 3:
            resultado='HIGIENIZACIÓN 1'
            break;
          case 4:
            resultado='HIGIENIZACIÓN 2'
            break;
          case 10:
            resultado='FIN DE CICLO'
            break;
        
          default:
            break;
        }
        return resultado
      },
      ultimo_estado(){
        let resultado='-'
        //Comprobación fase de higienización 1 por cada segundo
        if(this.ultima_temperatura_tromel < this.higienizacion1.temperaturaUmbral){
          this.set_fallo_hignienizacion1() 
        }
        //Comprobación fase de higienización 2
        if(this.ultima_temperatura_tromel < this.higienizacion2.temperaturaUmbral){
          this.set_fallo_hignienizacion2() 
        }

        // resultado = (this.tiempoFalloHigienizacion1 > this.higienizacion1.tiempoUmbral) ? 'FALLO HIGIENIZACION 1' : 'CORRECTO'
        // resultado = (this.tiempoFalloHigienizacion2 > this.higienizacion2.tiempoUmbral) ? 'FALLO HIGIENIZACION 2' : 'CORRECTO'

        if(this.tiempoFalloHigienizacion1 < this.higienizacion1.tiempoUmbral){ //Higienizacion1 OK
          if(this.tiempoFalloHigienizacion2 < this.higienizacion2.tiempoUmbral){ //Higienizacion2 OK
            resultado = 'CORRECTO'
          }else{
            resultado = 'FALLO HIGIENIZACION 2'
          }
        }else{
          resultado = 'FALLO HIGIENIZACION 1'
        }

        return resultado
      },
      ultima_temperatura_salida (){
        if (this.mensajes.datos.length < 1) return '?'
        return this.roundToTwo(this.mensajes.datos.slice(-1)[0].dato.Out_AI_Temp_Salida_Resistencias)
      }, 
      ultimo_caudal_aire (){
        if (this.mensajes.datos.length < 1) return '?'
        return this.roundToTwo(this.mensajes.datos.slice(-1)[0].dato.Out_AI_Caudal_Aire)
      }, 
      ultima_temperatura_tromel (){
        if (this.mensajes.datos.length < 1) return '?'
        return this.roundToTwo(this.mensajes.datos.slice(-1)[0].dato.Out_AI_Temp_Tromel)
      }, 
      titulo(){
        return this.items.find(a=>a.id==this.grafica_seleccionada).name;// [this.grafica_seleccionada].name
      },

      //Monstrará una imagen en rojo cuando baje de 80° en fase 2
      no_ok(){
        return this.mensajes.datos.filter(a=>a.dato<80 && a.fase===2).length>0
      },
      //Pintar los puntos en el gráfico    
      tempGrafico()
      {
        let nuevo={
          labels:[],
          datasets:[
            {
              data:[],
              segment:{
                        borderColor: ctx => this.choosePhaseColor(ctx),
                      },
              pointRadius: 0, //No pintar los puntos (para que solo se vea la linea)
            },
            ]} 

            //************************************DATOS DE PRUEBA ***************/
            // this.numEnsayo = 10
            // this.lote = 99
            // this.trabajador = "JOSE LUIS MARTINEZ"
            // this.mensajes.datos = [
            // {fecha:'2022-06-10T11:19:41+00',dato:{ "Out_AI_Caudal_Aire": 666, "Out_AI_Temp_Tromel": 92, "Out_AI_Temp_Salida_Resistencias": 15 },fase:1},
            // {fecha:'2022-06-10T11:19:42+00',dato:{ "Out_AI_Caudal_Aire": 666, "Out_AI_Temp_Tromel": 92, "Out_AI_Temp_Salida_Resistencias": 15 },fase:2},
            // {fecha:'2022-06-10T11:21:42+00',dato:{ "Out_AI_Caudal_Aire": 666, "Out_AI_Temp_Tromel": 92, "Out_AI_Temp_Salida_Resistencias": 15 },fase:2},
            // {fecha:'2022-06-10T11:22:42+00',dato:{ "Out_AI_Caudal_Aire": 666, "Out_AI_Temp_Tromel": 92, "Out_AI_Temp_Salida_Resistencias": 15 },fase:2},
            // {fecha:'2022-06-10T11:23:42+00',dato:{ "Out_AI_Caudal_Aire": 666, "Out_AI_Temp_Tromel": 92, "Out_AI_Temp_Salida_Resistencias": 15 },fase:2},
            // {fecha:'2022-06-10T11:24:42+00',dato:{ "Out_AI_Caudal_Aire": 666, "Out_AI_Temp_Tromel": 92, "Out_AI_Temp_Salida_Resistencias": 15 },fase:2},
            // {fecha:'2022-06-10T11:25:42+00',dato:{ "Out_AI_Caudal_Aire": 666, "Out_AI_Temp_Tromel": 92, "Out_AI_Temp_Salida_Resistencias": 15 },fase:2},
            // {fecha:'2022-06-10T11:26:42+00',dato:{ "Out_AI_Caudal_Aire": 666, "Out_AI_Temp_Tromel": 92, "Out_AI_Temp_Salida_Resistencias": 15 },fase:3},
            // {fecha:'2022-06-10T11:27:42+00',dato:{ "Out_AI_Caudal_Aire": 666, "Out_AI_Temp_Tromel": 92, "Out_AI_Temp_Salida_Resistencias": 15 },fase:3},
            // {fecha:'2022-06-10T11:28:42+00',dato:{ "Out_AI_Caudal_Aire": 666, "Out_AI_Temp_Tromel": 92, "Out_AI_Temp_Salida_Resistencias": 15 },fase:3},
            // {fecha:'2022-06-10T11:29:42+00',dato:{ "Out_AI_Caudal_Aire": 666, "Out_AI_Temp_Tromel": 92, "Out_AI_Temp_Salida_Resistencias": 15 },fase:3}]
            // //********************************************************************* */    
           

            this.mensajes.datos.forEach(element => {
               
              let prueba = new Date(element.fecha.replace(' ', 'T'));

              let a = moment(prueba).format('HH:mm:ss')
              
            
            //  moment(prueba).format('YYYY-MM-DD HH:mm')
            // nuevo.datasets[0].data.push({'x':this.getTimeFromDate(fecha_hora),'y':element.dato.Out_AI_Temp_Tromel,'fase':element.fase})
            // nuevo.datasets[0].data.push({'x':this.getTimeFromDate(a),'y':element.dato.Out_AI_Temp_Tromel,'fase':element.fase})
            nuevo.datasets[0].data.push({'x':a,'y':element.dato.Out_AI_Temp_Tromel,'fase':element.fase})
            nuevo.labels.push(a)
            });       
          return nuevo
      },

      tempSalidaResistenciasGrafico()
      {
        let nuevo={
          labels:[],
          datasets:[
            {
              data:[],
              segment:{
                        borderColor: ctx => this.choosePhaseColor(ctx),
                      },
              pointRadius: 0, //No pintar los puntos (para que solo se vea la linea)
            },
            ]} 

  
            this.mensajes.datos.forEach(element => {
                let prueba = new Date(element.fecha.replace(' ', 'T'));

              let a = moment(prueba).format('HH:mm:ss')
             


            nuevo.datasets[0].data.push({'x':a,'y':element.dato.Out_AI_Temp_Salida_Resistencias,'fase':element.fase})
            nuevo.labels.push(a)
            });       
          return nuevo
      },
      caudalGrafico()
      {
        let nuevo={
          labels:[],
          datasets:[
            {
              data:[],
              segment:{
                        borderColor: ctx => this.choosePhaseColor(ctx),
                      },
              pointRadius: 0, //No pintar los puntos (para que solo se vea la linea)
            },
            ]} 

  
            this.mensajes.datos.forEach(element => {
              let prueba = new Date(element.fecha.replace(' ', 'T'));

              let a = moment(prueba).format('HH:mm:ss')

             
            nuevo.datasets[0].data.push({'x':a,'y':element.dato.Out_AI_Caudal_Aire,'fase':element.fase})
            nuevo.labels.push(a)
            });       
          return nuevo
      },

      //Dibujar gráfica en función de lo seleccionado:
      datosGrafica(){

        //Temperatura tromel
        if(this.grafica_seleccionada==1){
          return this.tempGrafico
        }
        //Temperatura Salida de resistencias
        if(this.grafica_seleccionada==2){
          return this.tempSalidaResistenciasGrafico
        }
        //Caudal
        if(this.grafica_seleccionada==3){
          return this.caudalGrafico
        }
      },

      unidadesGrafica(){
        if(this.grafica_seleccionada==1){
          return "ºC"
        }
        //Temperatura Salida de resistencias
        if(this.grafica_seleccionada==2){
          return "ºC"
        }
        //Caudal
        if(this.grafica_seleccionada==3){
          return "m3/h"
        }
      },

      isTromel(){
        return (this.grafica_seleccionada==1)
      }
    }, //FIN DE COMPUTADOS


    //AL ARRANCAR EL PROYECTO ME SUSCRIBO A DOS CANALES
    mounted() {
      //Se suscribe al topic produccion para recibir los datos de producción
     
      this.doSubscribe('produccion')
     
     
      //Previamente ya estaba suscrito a los topic de ensayos y PREVIOS
      //Cuando reciba un mensaje se debe diferenciar el topic desde el que llega
      this.client.on('message', (topic, message) => {
        console.log(topic)
        //Datos relativos al ensayo (realizado por, lote MP, lote bolson, Cuerpos extraños,kg membrana y lote membrana)
        if(topic=="ensayos"){
          this.mensajes={
            datos:[],
            estados:[]
          }
         
          this.tratar_ensayos(message)
          //Limpiar datos de produccion

        }

        //Temperaturas de tromel y resistencias y caudal
        else if(topic=="produccion"){
          // console.log(message)
          this.tratar_produccion(message)
        }

        //Obtiene todos los datos de producción del ciclo actual (al cargar la página)
        else if(topic=="PREVIOS"){
          // alert("eee")
          this.tratar_previos(message)
        }
      
      })

    }, //FIN DE CREAR

    watch:{
    subscriptions(){
      if(this.subscriptions.includes('PREVIOS')) {
        let publication={
          topic:'conectado',
            qos:0,
            payload:JSON.stringify({'DAME_DATOS':true}) ,
          }
        console.log("publication: " + JSON.stringify(publication))
        this.doPublish(publication)
      }
    }
  },
    
  }
</script>

<style>
  .texto {
    text-align: center;
    background-color: rgb(230, 230, 230);
    font-size: 2em;
  }
  .icono{
    text-align: center;
    font-size: 2em;
  }
</style>